import { render, staticRenderFns } from "./AssetsCollectionConfirm.vue?vue&type=template&id=5a8c61f5&scoped=true"
import script from "./AssetsCollectionConfirm.vue?vue&type=script&lang=js"
export * from "./AssetsCollectionConfirm.vue?vue&type=script&lang=js"
import style0 from "./AssetsCollectionConfirm.vue?vue&type=style&index=0&id=5a8c61f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8c61f5",
  null
  
)

export default component.exports